import React from "react";
import { FiArrowLeft, FiShoppingCart, FiEye } from "react-icons/fi";
import { useNavigate, useParams } from "react-router-dom";

function PharmacyCategoryDetails() {
  const navigate = useNavigate();
  const { categoryName } = useParams(); // 👈 get name from URL

  // All categories and their product data
   const categories = {
    "Ayurvedic-Care": {
      image: "https://i.pinimg.com/736x/52/4a/19/524a194ad36c801fb6e73b35d2f1e1d0.jpg",
      description: "Explore herbal and ayurvedic health care products.",
      products: [
        {
          image: "https://i.pinimg.com/736x/3a/0c/15/3a0c15e2e9cc58a1f1ccedbca47a27b7.jpg",
          product: "Dabur Chyawanprash 500g",
          company: "Dabur India Ltd",
          mrp: "₹180",
          ptr: "₹140",
          status: "Available",
        },
        {
          image: "https://i.pinimg.com/736x/2c/2b/83/2c2b832cd38a7b20b9f54a0eb75b8a40.jpg",
          product: "Himalaya Ashwagandha Tablets",
          company: "Himalaya Wellness",
          mrp: "₹250",
          ptr: "₹190",
          status: "Available",
        },
        {
          image: "https://i.pinimg.com/736x/a9/9a/b0/a99ab05d28a88e2c17bb89eb7a7d9b67.jpg",
          product: "Patanjali Aloe Vera Gel",
          company: "Patanjali Ayurved Ltd",
          mrp: "₹95",
          ptr: "₹70",
          status: "Stock Out",
        },
      ],
    },

    "Medication": {
      image: "https://i.pinimg.com/736x/2b/66/db/2b66db81ba2345377152f9bdf35ce75f.jpg",
      description: "Find prescription and over-the-counter medicines for common health needs.",
      products: [
        {
          image: "https://i.pinimg.com/736x/46/29/b4/4629b4e10cda12b4dcf4a0304b9df08e.jpg",
          product: "Paracetamol 500mg Tab",
          company: "Cipla Ltd",
          mrp: "₹25.00",
          ptr: "₹18.50",
          status: "Available",
        },
        {
          image: "https://i.pinimg.com/736x/69/8f/6b/698f6b3f7a77e96737c8b2f3e844db24.jpg",
          product: "Amoxicillin 250mg Cap",
          company: "Sun Pharma",
          mrp: "₹45.00",
          ptr: "₹36.00",
          status: "Stock Out",
        },
      ],
    },

    "Mother-and-Baby-Care": {
      image: "https://i.pinimg.com/736x/8a/3d/2f/8a3d2fc5772a0253bd0fec3cd8b7d9d0.jpg",
      description: "Essential mother and baby care products for daily comfort and hygiene.",
      products: [
        {
          image: "https://i.pinimg.com/736x/7e/b5/da/7eb5da5bdf178cc493c21649a9b8f513.jpg",
          product: "Pampers Newborn Diapers",
          company: "P&G",
          mrp: "₹499",
          ptr: "₹420",
          status: "Available",
        },
        {
          image: "https://i.pinimg.com/736x/54/9e/63/549e63e216f8232b1e1da37950a35209.jpg",
          product: "Johnson's Baby Lotion 200ml",
          company: "Johnson & Johnson",
          mrp: "₹240",
          ptr: "₹190",
          status: "Available",
        },
      ],
    },

    "Surgicals-and-Medical-Devices": {
      image: "https://i.pinimg.com/736x/0e/76/8b/0e768bcd6ab51d8c31d9d6f83a37be23.jpg",
      description: "Surgical tools, diagnostic kits, and medical devices for home and hospital use.",
      products: [
        {
          image: "https://i.pinimg.com/736x/4b/21/a1/4b21a1cddfda98e9a6d7a35a26e6b1cb.jpg",
          product: "Accu-Chek Active Glucometer",
          company: "Roche Diagnostics",
          mrp: "₹999",
          ptr: "₹830",
          status: "Available",
        },
        {
          image: "https://i.pinimg.com/736x/d9/61/36/d9613679db3651a1ccfbde5ab2439cda.jpg",
          product: "Omron BP Monitor HEM-7120",
          company: "Omron Healthcare",
          mrp: "₹2499",
          ptr: "₹2100",
          status: "Available",
        },
      ],
    },

    "Beauty-and-Skincare": {
      image: "https://i.pinimg.com/736x/78/a8/70/78a87018870caefad6e76678ec99a9bc.jpg",
      description: "Discover beauty, skincare and self-care essentials for all skin types.",
      products: [
        {
          image: "https://i.pinimg.com/736x/25/a3/9d/25a39d2f6464bbce6ee7196e08eab61c.jpg",
          product: "Nivea Soft Moisturizing Cream 100ml",
          company: "Nivea",
          mrp: "₹299",
          ptr: "₹240",
          status: "Available",
        },
        {
          image: "https://i.pinimg.com/736x/f5/df/9f/f5df9fb89b4d9a89f8d7e8a55c471a8e.jpg",
          product: "Lakme Sun Expert SPF 30",
          company: "HUL",
          mrp: "₹240",
          ptr: "₹180",
          status: "Stock Out",
        },
      ],
    },

    "Personal-Care-and-Hygiene": {
      image: "https://i.pinimg.com/1200x/dd/b6/bf/ddb6bf8344fe60620f228800b9c4ea26.jpg",
      description: "Personal care and hygiene essentials to keep you clean and fresh every day.",
      products: [
        {
          image: "https://i.pinimg.com/736x/8b/f8/32/8bf83260b7724e0e65cc25b06a0107e9.jpg",
          product: "Colgate Total Toothpaste 150g",
          company: "Colgate Palmolive",
          mrp: "₹120",
          ptr: "₹90",
          status: "Available",
        },
        {
          image: "https://i.pinimg.com/736x/d2/f3/03/d2f3036c2d87c7b0f181a83f74c9fcd3.jpg",
          product: "Dove Intense Repair Shampoo 180ml",
          company: "HUL",
          mrp: "₹150",
          ptr: "₹115",
          status: "Available",
        },
      ],
    },

    "Nutraceutical": {
      image: "https://i.pinimg.com/736x/37/bf/1d/37bf1d697eaf89fb81374c18b862a7e2.jpg",
      description: "Vitamins, minerals, and nutritional supplements to support your health.",
      products: [
        {
          image: "https://i.pinimg.com/736x/38/7a/5d/387a5df4b4b00e3b0a93b118f127da7d.jpg",
          product: "Revital H Capsules (30s)",
          company: "Sun Pharma",
          mrp: "₹395",
          ptr: "₹310",
          status: "Available",
        },
        {
          image: "https://i.pinimg.com/736x/1f/73/f2/1f73f2a7c4a3fbcf7c7f52d8cb3c26b7.jpg",
          product: "Shelcal 500mg Tablets",
          company: "Torrent Pharma",
          mrp: "₹120",
          ptr: "₹95",
          status: "Stock Out",
        },
      ],
    },

    "Food-and-Nutrition": {
      image: "https://i.pinimg.com/736x/68/72/b8/6872b896e47102c87c832d3eadb6ae18.jpg",
      description: "Nutritional food and beverages to maintain a healthy, active lifestyle.",
      products: [
        {
          image: "https://i.pinimg.com/736x/4d/21/66/4d21669a2ff607e61c1a398eb7b92324.jpg",
          product: "Horlicks Classic Malt 500g",
          company: "GSK",
          mrp: "₹240",
          ptr: "₹200",
          status: "Available",
        },
        {
          image: "https://i.pinimg.com/736x/54/5a/62/545a62762e993e4b19e7b4ce7d84e508.jpg",
          product: "Ensure Nutritional Powder Vanilla 400g",
          company: "Abbott Nutrition",
          mrp: "₹625",
          ptr: "₹530",
          status: "Available",
        },
      ],
    },
  };


  // Normalize the category name (to match keys)
  const key = categoryName.replace(/\s+/g, "-");
  const data = categories[key] || categories["Ayurvedic-Care"]; // fallback if invalid

  return (
    <div className="p-4 bg-[#f8f8fb] min-h-screen font-sans text-gray-800">
      {/* Header */}
      <div className="flex flex-wrap justify-between items-center mb-6">
        <div className="flex items-center gap-3">
          <img
            src={data.image}
            alt={key}
            className="w-20 h-20 object-contain rounded-md"
          />
          <div>
            <h1 className="text-2xl font-bold">{key.replace(/-/g, " ")}</h1>
            <p className="text-gray-500 text-sm">{data.description}</p>
          </div>
        </div>

        <div className="flex items-center gap-3">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-green-600 hover:text-green-700 font-medium transition"
          >
            <FiArrowLeft className="text-lg" /> Go Back
          </button>

          <button className="gradient-button flex items-center gap-2 px-4 py-2 rounded-lg shadow text-white text-sm font-medium">
            <FiShoppingCart className="text-lg" /> Add to Cart
          </button>

          <button className="gradient-button flex items-center gap-2 px-4 py-2 rounded-lg shadow text-white text-sm font-medium">
            <FiEye className="text-lg" /> View Cart
          </button>
        </div>
      </div>

      {/* Table Section */}
      <div className="bg-white rounded-xl shadow-md overflow-x-auto">
        <table className="w-full text-sm border-collapse">
         <thead className="bg-green-50 text-gray-700 border-b sticky top-0 z-10">
  <tr>
    <th className="py-3 pl-4 pr-2 text-left">
      <input type="checkbox" style={{ accentColor: "#16a34a" }} />
    </th>
    <th className="py-3 px-4 text-left font-semibold">IMAGE</th>
    <th className="py-3 px-4 text-left font-semibold">PRODUCT</th>
    <th className="py-3 px-4 text-left font-semibold">CATEGORY</th>
    <th className="py-3 px-4 text-left font-semibold">MRP</th>
    <th className="py-3 px-4 text-left font-semibold">PTR</th>
    <th className="py-3 px-4 text-left font-semibold">MARGIN</th>
    <th className="py-3 px-4 text-left font-semibold">MY STATUS</th>
    <th className="py-3 px-4 text-left font-semibold">MIN | MAX</th>
    <th className="py-3 px-4 text-left font-semibold">STK</th>
  </tr>
</thead>

          <tbody>
  {data.products.map((p, i) => (
    <tr key={i} className="border-t hover:bg-green-50 transition">
      {/* Checkbox */}
      <td className="py-2 px-4">
        <input type="checkbox" style={{ accentColor: "#16a34a" }} />
      </td>

      {/* Product Image */}
      <td className="py-2 px-4">
        <img
          src={p.image}
          alt={p.product}
          className="w-10 h-10 object-contain rounded-md border"
        />
      </td>

      {/* Product Name */}
      <td className="py-2 px-4 font-medium text-gray-800">{p.product}</td>

      {/* Category */}
      <td className="py-2 px-4 text-gray-500">-</td>

      {/* MRP */}
      <td className="py-2 px-4">{p.mrp}</td>

      {/* PTR */}
      <td className="py-2 px-4">{p.ptr}</td>

      {/* Margin (static or calc) */}
      <td className="py-2 px-4 text-gray-500">-</td>

      {/* Status */}
      <td className="py-2 px-4">
       <span
  className={`inline-block px-3 py-1 rounded-md text-xs font-semibold whitespace-nowrap ${
    p.status === "Available"
      ? "bg-green-100 text-green-700"
      : "bg-red-100 text-red-600"
  }`}
>
  {p.status}
</span>

      </td>

      {/* Min | Max */}
      <td className="py-2 px-4 text-gray-500">-</td>

      {/* Stock */}
      <td className="py-2 px-4 text-gray-500">-</td>
    </tr>
  ))}
</tbody>

        </table>
      </div>
    </div>
  );
}

export default PharmacyCategoryDetails;
